import React from 'react';

const IconLogo = () => (
  <img src="/logo2.png" alt="Harshitha Sivalingala" style={{ width: '35px', height: '35px' }} />
);
export default IconLogo;
